export default __webpack_public_path__ + "static/media/ColourlessLand.69eca27e.png";